import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Form, Table, Image } from "react-bootstrap";
import axios from "axios";
import { BASE_URL, IMAGE_URL, security_key } from "../../../global";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";

const EditCategory = ({ showModal, handleClose, fetchAllCategory, category }) => {
    const formRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [imageError, setImageError] = useState("");

    const resetFormFields = (resetForm, setValues, initialValues) => {
        resetForm();
        setValues({
            ...initialValues,
        });
    };

    const initialValues = {
        pk_cat_key: category && category.pk_cat_key ? category.pk_cat_key : "",
        cat_name: category && category.cat_name ? category.cat_name : "",
        cat_description: category && category.cat_description ? category.cat_description : "",
        img_to_rem: category ? category.cat_img_mod : null,
        cat_img: null,
        cat_img_mod: category && category.cat_img_mod ? IMAGE_URL + category.cat_img_mod : "",
        updated_by: sessionStorage.getItem("pk_user_key"),
    };

    const basicSchema = Yup.object().shape({
        cat_name: Yup.string()
            .required("Category Name is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .min(3, "Category Name must be at least 3 characters.")
            .max(250, "Category Name must be at most 250 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            .matches(/^[a-zA-Z\s]*$/, "Special characters are not allowed.")
            // .matches(/^[^\s].*[^\s]$/, "No leading or trailing spaces are allowed.")
            .test("unique-link", "Category Name is already existing in the database", async function (value) {
                if (!value) return true;
                return await checkCategoryName(value);
            }),
        cat_description: Yup.string()
            .required("Category Description is required.")
            .test("no-leading-space", "No spaces allowed at the beginning.", function (value) {
                if (!value) return true;
                return !/^\s/.test(value);
            })
            .matches(/^[a-zA-Z0-9\s]*$/, "Special characters are not allowed.")
            .min(10, "Category Description must be at least 10 character.")
            .max(250, "Category Description must be at most 250 characters.")
            .test("no-trailing-space", "No spaces allowed at the end.", function (value) {
                if (!value) return true;
                return !/\s$/.test(value);
            })
            // .matches(
            //     /^[a-zA-Z][a-zA-Z\s.]*[a-zA-Z.]$/,
            //     "Category Description should only contain letters, spaces, and periods, and should not start or end with a space or period."
            // )
            .strict(),

        cat_img: Yup.mixed()
            .nullable()
            .test("fileType", "Unsupported File Format", (value) => {
                if (!value) return true;
                const supportedFormats = ["image/jpeg", "image/png", "image/gif"];
                return value ? supportedFormats.includes(value.type) : false;
            })
            .test("fileSize", "File size must be less than 2MB", (value) => {
                if (!value) return true;
                const maxSize = 2 * 1024 * 1024; // 2MB in bytes
                return value ? value.size <= maxSize : false;
            }),
    });

    async function checkCategoryName(cat_name) {
        const response = await axios.post(BASE_URL + "API/apicall", {
            security_key: security_key,
            mode: "checkCategoryName",
            cat_name: cat_name,
            pk_cat_key: values.pk_cat_key,
        });

        const output = response.data;

        return output == 1 ? false : true;
    }

    const formik = useFormik({
        initialValues,
        validationSchema: basicSchema,
        enableReinitialize: true,
        onSubmit: async (formValues) => {
            toast.dismiss();

            setIsSubmitting(true);

            const response = await axios.post(
                BASE_URL + "API/apicall",
                {
                    security_key: security_key,
                    mode: "updateCategory",
                    ...formValues,
                },
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            const output = response.data;
            if (output == 1) {
                // resetFormFields(resetForm, setValues, initialValues);
                handleClose();
                fetchAllCategory();
                toast.success("Updated successfully!", {
                    autoClose: 3000,
                });
            } else {
                toast.error("Oops! Something went wrong.", {
                    autoClose: 3000,
                });
            }
            setTimeout(function () {
                setIsSubmitting(false);
            }, 3000);
        },
    });

    // Now, you can set variables as needed:
    const values = formik.values;
    const handleBlur = formik.handleBlur;
    const touched = formik.touched;
    const handleChange = formik.handleChange;
    const errors = formik.errors;
    const handleSubmit = formik.handleSubmit;
    const setFieldValue = formik.setFieldValue;
    const setTouched = formik.setTouched;
    const resetForm = formik.resetForm;
    const setValues = formik.setValues;
    const handleReset = formik.handleReset;

    // const handleImageChange = (event) => {
    //     const file = event.currentTarget.files[0];
    //     if (file) {
    //         setFieldValue("cat_img", file);

    //         const reader = new FileReader();
    //         reader.onload = () => {
    //             setFieldValue("cat_img_mod", reader.result);
    //         };
    //         reader.readAsDataURL(file);
    //     }
    // };

    const handleImageChange = (event) => {
        const file = event.currentTarget.files[0];
        if (file) {
            // Check if the file is an image
            const fileType = file.type.split("/")[0];
            if (fileType !== "image") {
                setImageError("Unsupported file format. Please upload an image.");
                setFieldValue("cat_img", null);
                return;
            } else {
                setImageError(""); // Clear any previous error

                setFieldValue("cat_img", file);

                const reader = new FileReader();
                reader.onload = () => {
                    setFieldValue("cat_img_mod", reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
    };

    return (
        <>
            <Modal show={showModal} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Category</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit} ref={formRef}>
                        <Form.Group controlId="formImage" className="mb-3">
                            <div className="position-relative" style={{ cursor: "pointer" }}>
                                <img src={values.cat_img_mod} class="rounded mx-auto d-block mb-3" alt="..."></img>
                                <Form.Label className="position-absolute" style={{ top: "0px", right: "0px" }}>
                                    <i class="bi bi-pencil-square"></i>
                                </Form.Label>
                            </div>

                            <Form.Control
                                type="file"
                                onChange={handleImageChange}
                                // onChange={(event) => {
                                //     setFieldValue("cat_img", event.currentTarget.files[0]);
                                //     setFieldValue("cat_img_mod", event.currentTarget.files[0]);
                                // }}
                                onBlur={handleBlur}
                                accept="image/*"
                                style={{ display: "none" }}
                            />
                            {imageError && <p className="text-danger">{imageError}</p>}
                            {errors.cat_img && touched.cat_img && <p className="text-danger">{errors.cat_img}</p>}
                        </Form.Group>

                        <Form.Group controlId="cat_name" className="mb-3">
                            <Form.Label>
                                Category Name <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control type="text" value={values.cat_name} onChange={handleChange} onBlur={handleBlur} placeholder="Enter category name" />
                            {errors.cat_name && touched.cat_name && <p className="text-danger">{errors.cat_name}</p>}
                        </Form.Group>
                        <Form.Group controlId="cat_description" className="mb-3">
                            <Form.Label>
                                Description <span className="text-danger">*</span>{" "}
                            </Form.Label>
                            <Form.Control
                                // type="text"
                                as="textarea"
                                rows={3}
                                value={values.cat_description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                placeholder="Enter category description"
                            />
                            {errors.cat_description && touched.cat_description && <p className="text-danger">{errors.cat_description}</p>}
                        </Form.Group>

                        <div className="mt-3">
                            <Button variant="dark" type="submit" disabled={isSubmitting}>
                                Save Category
                            </Button>
                            <Button variant="outline-secondary" className="ms-2" onClick={handleClose}>
                                Cancel
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default EditCategory;
